import { QuoteRatingSearchRequestQuery } from '@lio/api-types';

export const quoteRatingQueryKey = {
  resource: 'quoteRating',
  getWithParams: (quoteId?: string, quoteRatingId?: string) =>
    [quoteRatingQueryKey.resource, quoteId, quoteRatingId] as const,
  searchWithParams: (quoteId?: string, params?: QuoteRatingSearchRequestQuery) =>
    [quoteRatingQueryKey.resource, quoteId, params] as const,
  searchWithoutInfiniteParams: (quoteId?: string, params?: QuoteRatingSearchRequestQuery) =>
    [quoteRatingQueryKey.resource, quoteId, 'non-infinite', params] as const,
};
